import { defineMessages } from 'react-intl';

export const messages: {
	pageLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	spaceLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	blogpostLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	attachmentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	pageLabel: {
		id: 'search-graph-confluence-dc.document.pageLabel',
		defaultMessage: 'Page',
		description: 'Label for a DC document page search result.',
	},
	spaceLabel: {
		id: 'search-graph-confluence-dc.document.spaceLabel',
		defaultMessage: 'Space',
		description: 'Label for a DC document space search result.',
	},
	blogpostLabel: {
		id: 'search-graph-confluence-dc.document.blogpostLabel',
		defaultMessage: 'Blog Post',
		description: 'Label for a DC document blog post search result.',
	},
	commentLabel: {
		id: 'search-graph-confluence-dc.document.commentLabel',
		defaultMessage: 'Comment',
		description: 'Label for a DC document comment search result.',
	},
	attachmentLabel: {
		id: 'search-graph-confluence-dc.document.attachmentLabel',
		defaultMessage: 'Attachment',
		description: 'Label for a DC document attachment search result.',
	},
});
